import { Header } from "@/components/Header";
import { useSEO } from "@/hooks/use-seo";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { CasinoRankings } from "@/components/CasinoRankings";
import { GameShowcase } from "@/components/GameShowcase";
import { EditorialSection } from "@/components/EditorialSection";
import { FeaturedReviews } from "@/components/FeaturedReview";
import { DecisionGuide } from "@/components/DecisionGuide";
import { ComparisonTable } from "@/components/ComparisonTable";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";
export default function Home() {
  useSEO({ title: "Online Kasina 2026 – Nejlepší bonusy a recenze v ČR | HrajBonus", description: "Nezávislé recenze a srovnání online kasin pro české hráče. Nejlepší bonusy, free spiny a žebříček top 20 kasin 2026. Hrajte zodpovědně. 18+",
  url: "https://hrajbonus.com/", });

  return (
    <div className="min-h-screen" style={{ fontFamily: "Poppins, sans-serif" }}>
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <div id="zebricek" style={{ marginTop: "-2px" }}><CasinoRankings /></div>
        <GameShowcase />
        <EditorialSection />
        <FeaturedReviews />
        <DecisionGuide />
        <ComparisonTable />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}
